import { render, staticRenderFns } from "./SettingsDelivery.vue?vue&type=template&id=03bed15b&scoped=true"
import script from "./SettingsDelivery.vue?vue&type=script&lang=js"
export * from "./SettingsDelivery.vue?vue&type=script&lang=js"
import style0 from "./SettingsDelivery.vue?vue&type=style&index=0&id=03bed15b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bed15b",
  null
  
)

export default component.exports